
/**
 * 
 * @returns {WeakSet}
 */
function useWeakSet() {
    const weakMap = new WeakSet(...arguments);
    return weakMap;
}

export default useWeakSet;